<div class="active" mat-dialog-title>
    {{ 'sla.ui-material.version.label' | translate }}
</div>

<div mat-dialog-content class="dialog-content">
    <table mat-table [dataSource]="displayedVersions">
        <ng-container *ngFor="let column of displayedColumns">
            <ng-container [ngSwitch]="column">
                <ng-container *ngSwitchDefault [matColumnDef]="column">
                    <td *matCellDef="let element" mat-cell> {{ element[column] }}</td>
                </ng-container>
            </ng-container>
        </ng-container>

        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <table mat-table *ngIf="additionalInfo?.length" [dataSource]="additionalInfo">
        <ng-container *ngFor="let column of additionalInfoColumns">
            <ng-container [ngSwitch]="column">
                <ng-container *ngSwitchDefault [matColumnDef]="column">
                    <td *matCellDef="let element" mat-cell> {{ element[column] }}</td>
                </ng-container>
            </ng-container>
        </ng-container>

        <tr mat-row *matRowDef="let row; columns: additionalInfoColumns;"></tr>
    </table>
</div>

<div class="actions" mat-dialog-actions>
    <button (click)="resetCache()"
            class="medium-touch-btn"
            color="primary"
            style="min-width: 150px;"
            mat-flat-button>
        {{ 'sla.ui-material.version.clear-cache.label' | translate }}
    </button>
    <button (click)="toggleVersionDetail()"
            class="medium-touch-btn"
            style="width: 150px"
            color="primary"
            mat-flat-button>
        {{ 'sla.ui-material.version.show-details.label' | translate }}
    </button>
    <button mat-flat-button
            [mat-dialog-close]="true"
            color="primary"
            style="width: 150px"
            class="medium-touch-btn">
        {{ 'sla.ui-material.version.close.label' | translate }}
    </button>
</div>
